import { QuestionnaireCategory } from '@/models/gen/graphql';
import { Schema } from '@/utils';

export namespace CategoryFormDefinitions {
  export type Value = Partial<QuestionnaireCategory> & { groupIds?: string[] };
  export const initValue: Value = {
    name: '',
    description: '',
    color: '',
    groupIds: [],
  };
  export const validator = Schema((z) =>
    z.object({
      name: z.string().min(1, { message: 'Required' }),
      description: z.string().min(1, { message: 'Required' }),
      color: z.string().min(1, { message: 'Required' }),
      groupIds: z.array(z.string()).optional(),
    })
  );
}
